export default function blurInputs(container) {
    let inputs = container.querySelectorAll("input:focus, textarea:focus") || [];

    inputs.forEach(input => {
        input.blur();
    });
}
